import React from 'react'

function CheckCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12l2.5 2.5L16 9" />
    </svg>
  )
}

interface SaveButtonProps {
  onClick: () => void
  size?: string
  className?: string
}

export default function SaveButton({
  onClick,
  size,
  className,
}: SaveButtonProps) {
  const handleSaveClick = () => {
    onClick()
  }

  const sizeButtonClasses =
    size === 'tiny' ? 'h-5 w-5 min-w-5 content center' : 'h-fit px-4 py-2 h5'

  return (
    <button
      className={`text-white bg-transparent border-none ${sizeButtonClasses} ${className}`}
      // className="mt-1 ms-1 me-4 rounded-full text-xs bg-red-100 text-white"
      onClick={handleSaveClick}
    >
      {!size ? 'Salvar' : <CheckCircleIcon className="h-5 w-5 inline-block" />}
    </button>
  )
}
